<script>
import OrganizationItemCreateAndEdit from "@/pages/admin/organizations/tabs/create_and_edit/OrganizationItemCreateAndEdit.vue";
import OrganizationInfoLayout from "@/pages/admin/organizations/components/OrganizationInfoLayout.vue";

export default {
  name: "DataOrganization",
  components: { OrganizationItemCreateAndEdit, OrganizationInfoLayout },
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    uuid() {
      return this.$route.params.id;
    },
    showForm() {
      return (
        this.$route.name === "organization_new" ||
        this.$route.name === "organization_item"
      );
    },
    headerData() {
      return {
        title: this.$t("Данные организации"),
        info: [
          {
            label: this.$t("Наименование организации"),
            value: this.form.name,
          },
          {
            label: this.$t("БИН"),
            value: this.form.bin,
          },
        ],
      };
    },
    sections() {
      return [
        {
          title: this.$t("Основные данные"),
          items: [
            {
              label: this.$t("Наименование организации"),
              values: [
                { lang: this.$t("Рус"), text: this.form.name },
                { lang: this.$t("Қаз"), text: this.form.name_kz },
              ],
            },
            {
              label: this.$t("Краткое наименование организации"),
              values: [
                { lang: this.$t("Рус"), text: this.form.short_name_ru },
                { lang: this.$t("Қаз"), text: this.form.short_name_kz },
              ],
            },
            {
              label: this.$t("Дата создания организации"),
              values: [{ text: this.form.created_at || this.$t("Не указано") }],
            },
            {
              label: this.$t("Код организации"),
              values: [{ text: this.form.code || this.$t("Не указано") }],
            },
          ],
        },
        {
          title: this.$t("Данные руководителя и адрес"),
          items: [
            {
              label: this.$t("ФИО руководителя организации"),
              values: [
                { text: this.form.head_full_name || this.$t("Не указано") },
              ],
            },
            {
              label: this.$t("Должность руководителя"),
              values: [
                {
                  lang: this.$t("Рус"),
                  text: this.form.head_position_ru || this.$t("Не указано"),
                },
                {
                  lang: this.$t("Қаз"),
                  text: this.form.head_position_kz || this.$t("Не указано"),
                },
              ],
            },
            {
              label: this.$t("Юридический адрес"),
              values: [
                {
                  lang: this.$t("Рус"),
                  text: this.form.legal_address_ru || this.$t("Не указано"),
                },
                {
                  lang: this.$t("Қаз"),
                  text: this.form.legal_address_kz || this.$t("Не указано"),
                },
              ],
            },
          ],
        },
        {
          title: this.$t("Контактные данные"),
          items: [
            {
              label: this.$t("Контактные данные"),
              values: [{ text: this.form.phone || this.$t("Не указано") }],
            },
            {
              label: "Е-mail",
              values: [{ text: this.form.email || this.$t("Не указано") }],
            },
            {
              label: "Сайт",
              values: [{ text: this.form.website || this.$t("Не указано") }],
            },
          ],
        },
        {
          title: this.$t("Данные счета"),
          items: [
            {
              label: this.$t("Наименование банка"),
              values: [{ text: this.form.bank_name || this.$t("Не указано") }],
            },
            {
              label: this.$t("ИИК"),
              values: [{ text: this.form.iik || this.$t("Не указано") }],
            },
            {
              label: this.$t("БИК"),
              values: [{ text: this.form.bik || this.$t("Не указано") }],
            },
            {
              label: this.$t("КБЕ"),
              values: [{ text: this.form.kbe || this.$t("Не указано") }],
            },
          ],
        },
      ];
    },
  },
  methods: {
    async validate() {
      const form = this.$refs.activeForm;
      if (form && form.validate) {
        return await form.validate();
      }
      return true;
    },
    setServerErrors(detail) {
      const form = this.$refs.activeForm;
      if (form && form.setServerErrors) {
        form.setServerErrors(detail);
      }
    },
  },
};
</script>

<template>
  <div class="h-full overflow-auto">
    <div v-if="showForm" class="flex flex-col gap-6 w-full h-full">
      <div class="flex flex-col gap-3 h-full">
        <OrganizationItemCreateAndEdit
          ref="activeForm"
          :form="form"
        ></OrganizationItemCreateAndEdit>
      </div>
    </div>
    <div v-else class="organization-block">
      <OrganizationInfoLayout
        :showHeader="true"
        :headerData="headerData"
        :sections="sections"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.organization-block {
  @apply h-full rounded-2xl p-8 w-1/2;
  border: 1px solid hsl(var(--border));
  background-color: hsl(var(--background));
}
</style>
